var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-body" }, [
    _c("div", { staticClass: "row justify-content-center" }, [
      _c(
        "div",
        { staticClass: "col-md-8" },
        [
          _vm.authenticationError
            ? _c(
                "b-alert",
                {
                  attrs: {
                    show: "",
                    "data-cy": "loginError",
                    variant: "danger"
                  }
                },
                [
                  _c("strong", [_vm._v("Failed to sign in!")]),
                  _vm._v(
                    " Please check your credentials and try again.\n      "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-8" },
        [
          _c(
            "b-form",
            {
              attrs: { role: "form" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.doLogin()
                }
              }
            },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Username", "label-for": "username" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "username",
                      type: "text",
                      name: "username",
                      autofocus: "",
                      placeholder: "Your username",
                      "data-cy": "username"
                    },
                    model: {
                      value: _vm.login,
                      callback: function($$v) {
                        _vm.login = $$v
                      },
                      expression: "login"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                { attrs: { label: "Password", "label-for": "password" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "password",
                      type: "password",
                      name: "password",
                      placeholder: "Your password",
                      "data-cy": "password"
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-checkbox",
                {
                  attrs: { id: "rememberMe", name: "rememberMe", checked: "" },
                  model: {
                    value: _vm.rememberMe,
                    callback: function($$v) {
                      _vm.rememberMe = $$v
                    },
                    expression: "rememberMe"
                  }
                },
                [_c("span", [_vm._v("Remember me")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        "data-cy": "submit",
                        type: "submit",
                        variant: "primary"
                      }
                    },
                    [_vm._v("Sign in")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("p")
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }